import { Stack, Typography } from '@mui/material';
import { FC } from 'react';

export type VyRadioCardLabelProps = {
  title: string;
  description: string;
};

export const VyRadioCardLabel: FC<VyRadioCardLabelProps> = ({ title, description }) => (
  <Stack spacing={0.5}>
    <Typography variant="h6" sx={{
      fontWeight: 400
    }}>
      {title}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        color: "text.secondary",
        lineHeight: 1.5
      }}>
      {description}
    </Typography>
  </Stack>
);
